import React from "react";
import { useNavigate } from "react-router-dom";
import { getDateByString } from "../../libs/utils";
import moment from "moment";
import { DATE_FORMAT_FOR_DISPLAY } from "../../constants/constants";
import { Tooltip } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const ENABLED_COMPANIES_FEATURE = process.env.REACT_APP_NEW_DOCS_COMPANIES;
const NEW_DOC_REDIRECT_URL = process.env.REACT_APP_NEW_DOC_REDIRECT_URL;

const BoxListingEventRow = ({invoiceId, date, lines, key, truncate,getWorkspaceId}) => {
  const navigate = useNavigate();
  const goToDocumentDetail = invoiceId => navigate(`/dettaglio-documento/${invoiceId}?from=dashboard`);
  const goToNewDocumentDetail = invoiceId => navigate( NEW_DOC_REDIRECT_URL + `/document-details/${invoiceId}/${getWorkspaceId?.id}?embed=true`);

  let dateAndImport = "";
  let companyName = "";
  let realDate = "";
  if (date && date.trim().length > 0) {
    realDate = getDateByString(date);
    dateAndImport = (
      <div>
        <b className="list-daynumber">
          {moment(realDate).format(DATE_FORMAT_FOR_DISPLAY)}
        </b>
        <br />
        <b>{lines.line3}</b>
      </div>
    );
  }

  if (lines && lines.line1) {
    companyName = lines.line1;

    if (truncate && lines.line1.length > 60) {
      companyName = lines.line1.substr(0, 60) + "...";
    }
  }
  return (
    <div
      key={key}
      className="containerFlex boxListing"
      style={{
        fontSize: "12px",
        padding: "8px",
        borderBottom: "1px solid #eaeaf5"
      }}
      onClick={ENABLED_COMPANIES_FEATURE ? ()=> goToNewDocumentDetail : () => goToDocumentDetail(invoiceId)}
    >
      <div
        className="columnFlexPx"
        style={{ padding: "0 8px", lineHeight: "20px" }}
      >
        {dateAndImport}
      </div>
      <div
        className="columnFlex80"
        style={{ paddingRight: "16px", lineHeight: "20px" }}
      >
        <div>
          {lines && lines.line2 ? (
            <div
              id="invoiceNumber"
              style={{ fontWeight: "bold", fontSize: "14px" }}
              key={key + "_line2"}
            >
              {`Fattura ${lines.line2.toLowerCase()}`}
            </div>
          ) : (
            <div key={key + "_line2"}>{`Fattura ${moment(realDate).format(DATE_FORMAT_FOR_DISPLAY)}`}</div>
          )}
          {lines && lines.line1 ? (
            <div
              id="companyName"
              key={key + "_line1"}
              style={{ fontWeight: "normal" }}
            >
              {companyName.replace(",", "")}
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
      <div className="columnFlex10">
        <Tooltip placement="left" title={"Vai al dettaglio"} color={"rgb(0, 80, 117)"}>
          <FontAwesomeIcon
            icon={["fas", "arrow-right"]}
            style={{ color: "#0090d1", cursor: "pointer" }}
          />
        </Tooltip>
      </div>
    </div>
  );
};

export default BoxListingEventRow;